import React, {useState} from 'react';

import {ButtonStyle} from 'ui-library/buttons/Button';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import {LabelStyle, Size} from 'ui-library/inputs/InputConstants';
import TextField from 'ui-library/inputs/TextField';
import legacyRunModal from 'ui-library/legacyRunModal';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';
import Section from 'ui-library/menus/Section';
import Modal from 'ui-library/modals/Modal';

interface AutomationFileFormatCustomModalProps {
  initialValue: string;
  label: string;
  maxValueLength?: number;
  onRequestClose: () => void;
  onRequestSubmit: (value: string) => void;
}

function AutomationFileFormatCustomModal(props: AutomationFileFormatCustomModalProps): JSX.Element {
  const [value, setValue] = useState(props.initialValue);
  return (
    <Modal
      buttons={[
        {
          style: ButtonStyle.SECONDARY,
          submit: true,
          disabled: value == null || value === '',
          text: 'Submit',
        },
      ]}
      onRequestClose={props.onRequestClose}
      onRequestSubmit={() => {
        props.onRequestSubmit(value);
      }}
      title={`Set custom ${props.label.toLocaleLowerCase()}`}
    >
      <TextField
        label={props.label}
        labelStyle={LabelStyle.LABEL}
        value={value}
        maxLength={props.maxValueLength}
        size={Size.MEDIUM}
        onChange={(e) => {
          setValue(e.target.value);
        }}
      />
    </Modal>
  );
}

interface AutomationFileConfigFileFormatInputProps {
  label: string;
  onSelect: (value: string) => void;
  options: {[key: string]: string};
  value: string;
  allowCustomValue?: boolean;
}

export const CUSTOM = 'CUSTOM';
export default function AutomationFileConfigFileFormatInput(
  props: AutomationFileConfigFileFormatInputProps
): JSX.Element {
  const allowCustom = props.allowCustomValue !== false;
  const quickValueSelected = props.options[props.value] !== undefined;

  const selectedValue = quickValueSelected ? props.value : CUSTOM;

  return (
    <SelectDropdown
      displayName={props.options[props.value] || `Custom value (${props.value})`}
      menu={
        <Menu value={selectedValue} height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.FULL} scrollable={true}>
          <Section>
            {Object.entries(props.options).map(([value, display]) => (
              <Option
                key={value}
                value={value}
                onSelect={() => {
                  props.onSelect(value);
                }}
              >
                {display}
              </Option>
            ))}
          </Section>
          {allowCustom && (
            <Option
              value={CUSTOM}
              onSelect={() => {
                legacyRunModal(AutomationFileFormatCustomModal, {
                  label: props.label,
                  initialValue: props.value,
                  onRequestSubmit: (value: string) => {
                    props.onSelect(value);
                  },
                });
              }}
            >
              Custom value
            </Option>
          )}
        </Menu>
      }
    />
  );
}
